export enum ERequestedKPI {
  NetValue = "NetValue",
  SalesCounting = "SalesCounting",
  AverageTicket = "AverageTicket",
  UnregisteredCardFees = "UnregisteredCardFees",
  DesempenhoVendas = "DesempenhoVendas",
  YesterdaySales = "YesterdaySales"
}

export enum EGoupReturnBy {
  Day = "Day",
  Month = "Month",
  Year = "Year",
  DayStore = "DayStore",
  Store = "Store",
  MonthStore = "MonthStore",
  YearStore = "YearStore",
  DayModality = "DayModality",
  ModalityDetails = "ModalityDetails",
  Modality = "Modality",
  StoreModality = "StoreModality",
  CommercialGroup = "CommercialGroup",
  StoreBankingAccount = "StoreBankingAccount",
  Adquirentes = "Adquirentes" // TODO: fix
}

export interface IKPI {
  handler(response: IGetResponseBase[] | undefined): IGetResponseBase[];
}

export type TPagarEreceberHoje = {
  pendente: number;
  pago: number;
  total: number;
};

export type TDivergenciaTaxasItem = IGetResponseBase & {
  divergenciaMonetaria?: number | null;
};

export type TListDivergencias = {
  divergencias?: TDivergenciaTaxasItem[];
  listOne?: TDivergenciaTaxasItem[];
  listTwo?: TDivergenciaTaxasItem[];
  total?: number;
};

export type TListAlugueisDivergencias = {
  divergenciasPositivas: IGetResponseBase[];
  divergenciasNegativas: IGetResponseBase[];
};

export type TReceitasVencidas = {
  valorReceitasVencidas: number;
  qtdParcelasVencidas: number;
};

export type TResultResponse = {
  pmr?: number;
  modalityDescription?: string;
  modalityId?: string;
  qtdConciliado?: number;
  qtdPendente?: number;
  pctConciliacao?: number;
  tipoRegistro?: number;
};

export type TResultDetalhesReceitasVencidas = {
  numeroBanco: number;
  nomeConta: string;
  nomeEmpresa: string;
  valorTotal: number;
  meiosDePagamento: { nome: string; valor: number }[];
};

export type TResultDetalhesVendasHoje = {
  totalRegistros: number;
  totalRecebidos: number;
  totalNaoRecebidos: number;
  detalhesAgrupamento: {
    numeroBanco: number;
    nomeConta: string;
    nomeEmpresa: string;
    valorPago: number;
    valorPentende: number;
    valorTotal: number;
    meiosDePagamento: {
      nome: string;
      valorPago: string;
      valor: string;
      valorPentende: number;
    }[];
  }[];
};

export type TResponseBandeirasDetalhes = {
  bandeira: string;
  codigoDoEstabelecimento: string;
  dataVenda: string;
  meioDePagamento: string;
  nomeEmpresa: string;
  operadora: string;
  bandeiraId?: number;
};

export interface IChartDesempenhoVendasGraphicValues {
  key: string;
  value: number;
  ticketMedio: number;
  amount: number;
}
export interface IChartDesempenhoVendasValues {
  up: string;
  down: string;
}

export interface IChartVendasCanceladasItemValue {
  quantidade?: number;
  valor?: number;
}

export type TResponseAluguelPOSPendentesDetalhes = {
  adquirente: string;
  codigoDoEstabelecimento: string;
  dataVigencia: string;
  empresa: string;
};

export interface IGetResponseBase<T = TResultResponse> {
  comparedSaleDate?: string | null;
  saleDate?: string | null;
  totalComparedValue?: number | null;
  totalValue?: number | null;
  storeId?: string;
  modalityId?: string;
  cardAcquirer?: string;
  cardEntryType?: string;
  cardFlag?: string;
  establishmentCode?: number;
  storeName?: string;
  modalityDescription?: string;
  cardFlagId?: number;
  notaTituloGerado?: number;
  notaSemTitulo?: number;
  notaNegada?: number;
  notaSimplificada?: number;
  valorTotalNfe?: number;
  bankingAccountId?: string;
  bankingAccountDescription?: string;
  valorAcordado?: number;
  percentage?: number;
  result?: T;
  code?: number;
  quantity?: number;

  transacao?: IChartDesempenhoVendasValues;
  ticketMedio?: IChartDesempenhoVendasValues;
  venda?: IChartDesempenhoVendasValues;
  grafico?: IChartDesempenhoVendasGraphicValues[];

  // Vendas Canceladas
  total?: IChartVendasCanceladasItemValue;
  vendasCanceladas?: IChartVendasCanceladasItemValue;
  vendasChargeback?: IChartVendasCanceladasItemValue;

  // Fechamento de Caixa
  empresasFechamentoDeCaixa?: IEmpresasFechamentoDeCaixa[];
  totalDiasFechamentoDeCaixa?: number;
  adquirente: string;
  diferenca: number;
  empresa: string;
  pago: number;
}

export interface IListResponse {
  data: IGetResponseBase[];
}

export interface IFilterParams {
  initialDate: string | undefined;
  finalDate: string | undefined;
  groupReturnBy: string;
  targetWidget: string;
  requestedKPI?: string;
  contasReceber?: boolean;
  contasPagar?: boolean;
  storeIds?: string;
  settled?: boolean;
  type?: string;
  newTax?: boolean;
}

export interface IFilterParamsReceberHoje {
  storeIds: string;
}

export interface IParamsDRE {
  _id?: string;
  modeloDREId: string;
  preferenciaPadrao: boolean;
  preferencias: {
    nome: string;
    id: string;
    apelido?: string;
    analiseVertical: string;
    total: string;
  }[];
}

export type IPreferenciasDRECard = {
  id: string;
  nome: string;
  apelido: string;
  total: string;
  analiseVertical: string;
};

export interface IReturnDREPreference {
  customer: {
    _id: string;
  };
  preferenciaPadrao: boolean;
  modeloDREId: string;
  preferencias: IPreferenciasDRECard[];
  _id: string;
  timestamp: string;
  updatedAt: string;
}

export interface IFilterParamsDesempenhoVendas {
  initialDate: string | undefined;
  finalDate: string | undefined;
  type: string;
  storeIds: string | undefined;
  requestedKPI?: string;
  groupReturnBy?: string;
  targetWidget?: string;
}

export interface IChartDesempenhoVendasGraphicValues {
  chave: string;
  preco: number;
  ticketMedio: number;
  quantidade: number;
}
export interface IChartDesempenhoVendasValues {
  aumentou: string;
  abaixou: string;
}
export type IChartDesempenhoVendasResult = {
  transacao?: IChartDesempenhoVendasValues;
  ticketMedio?: IChartDesempenhoVendasValues;
  venda?: IChartDesempenhoVendasValues;
  grafico?: IChartDesempenhoVendasGraphicValues[];
};

export interface IVendasCanceladasResponse {
  total?: IChartVendasCanceladasItemValue;
  vendasCanceladas?: IChartVendasCanceladasItemValue;
  vendasChargeback?: IChartVendasCanceladasItemValue;
}

export interface IVendasCanceladasParams {
  storeIds?: string;
  type?: string;
  initialDate: string;
  finalDate?: string;
}

export interface IEmpresasFechamentoDeCaixa {
  empresaId: string;
  totalDeDias: number;
  data: string;
  nomeFantasia: string;
}

export interface IFechamentoCaixaResponse {
  fechamentosRecentes?: number;
  fechamentosAtrasados?: number;
  empresasFechamentoDeCaixa?: IEmpresasFechamentoDeCaixa[];
  totalDiasFechamentoDeCaixa?: number;
}

export interface IFechamentoCaixaParams {
  storeIds?: string;
  initialDate?: string;
  finalDate?: string;
}

export interface ICieloFitInteresseResponse {
  success?: boolean;
  data?: {
    statusCode?: number;
    interesseModuloFit?: boolean;
    mensagem?: string;
    stackTrace?: string;
    email?: string;
    customerId?: string;
  };
}

export interface IAdquirestesPorVendasResponse {
  quantidade: number;
  valor: number;
  adquirente: string;
}

export interface IVendasPorAdquirenteResponse {
  adquirentes: IAdquirestesPorVendasResponse[];
}
